import { IonButton, IonButtons, IonCol, IonContent, IonGrid, IonIcon, IonPage, IonRow, IonToolbar, useIonViewWillEnter } from '@ionic/react';
import { addOutline } from 'ionicons/icons';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import CampaignCardEdit from '../../components/CampaignCardEdit';
import Footer from '../../components/Footer';
import { Fundraiser, User } from '../../models/data';
import { translation } from '../../models/translation';
import { fetchUserFundraisers } from '../../services/fundraise_service';

interface FundraiseByUserListProps {
  user: User | null
}

const FundraiseByUserList: React.FC<FundraiseByUserListProps> = ({ user }) => {
  const history = useHistory();

  const siteText = translation();

  const [fundraiseList, setFundraiseList] = useState<[Fundraiser]>(
  );

  const navigate = (e: string, edit?: boolean) => {
    if (!edit) {
      history.push(`./fundraisers/${e}`);
    } else {
      history.push(`./fundraisers/edit/${e}`);
    }
  }

  
  useIonViewWillEnter(() => {
    loadFundraiserList();

  })

  const loadFundraiserList = async () => {
    let data = await fetchUserFundraisers(user?.id);
    if (data) {
      setFundraiseList(data.message);
    }

  }

  return (

    <IonPage >
      <IonContent>
        <IonGrid className='pageContent' >
          <IonRow>
            <IonCol offset='1' size='11' className='ion-text-uppercase'>
              <h1>{siteText.fundraiseTitle}</h1>
            </IonCol>
          </IonRow>
          <IonRow>
            {user && <IonCol offset='1' size='10'>
              <IonToolbar mode='md' >
                <IonButtons className='fundraiserTabs'>
                  <IonButton routerLink={siteText.lan+'/account/fundraise' }>{siteText.fundraiseAllSectTitle}</IonButton>
                  <IonButton className='active'>{siteText.fundraiseUserSectTitle}</IonButton>
                  <IonButton routerLink={siteText.lan+'/account/fundraisercreate' }color='primary' fill='clear'>{siteText.fundraiseCreateTitle}<IonIcon icon={addOutline} /></IonButton>
                </IonButtons>
              </IonToolbar>
            </IonCol>}
          </IonRow>
          <IonRow>
            {fundraiseList ? fundraiseList.map((m, key) => {
              return <CampaignCardEdit key={key} status={m.acf.status} title={m.title.rendered} reason={m.acf.reason} imageUrl={m.acf.image} id={m.id} navigate={navigate} 
               ></CampaignCardEdit>
            }) : ''}
          </IonRow>
        </IonGrid>

        <Footer></Footer>
      </IonContent>
    </IonPage>
  );
};

export default FundraiseByUserList;
